import { render } from "./PaymentsWidget.vue?vue&type=template&id=b20bd846&ts=true"
import script from "./PaymentsWidget.vue?vue&type=script&lang=ts"
export * from "./PaymentsWidget.vue?vue&type=script&lang=ts"

import "./PaymentsWidget.vue?vue&type=style&index=0&id=b20bd846&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__